/* eslint-disable react/jsx-props-no-spreading */
import { hot } from 'react-hot-loader/root'

import '@piconetworks/account/dist/index.css'
import '@piconetworks/avatar/dist/index.css'
import '@piconetworks/badge/dist/index.css'
import '@piconetworks/button/dist/index.css'
import '@piconetworks/boutton/dist/index.css'
import '@piconetworks/cards/dist/index.css'
import '@piconetworks/choose-newsletter/dist/index.css'
import '@piconetworks/confirm-payment/dist/index.css'
import '@piconetworks/content-container/dist/index.css'
import '@piconetworks/content-footer/dist/index.css'
import '@piconetworks/error-with-card/dist/index.css'
import '@piconetworks/gift/dist/index.css'
import '@piconetworks/form/dist/index.css'
import '@piconetworks/icon/dist/index.css'
import '@piconetworks/loading/dist/index.css'
import '@piconetworks/landing-wizard-arrow/dist/index.css'
import '@piconetworks/login/dist/index.css'
import '@piconetworks/payment-badge/dist/index.css'
import '@piconetworks/select-newsletters/dist/index.css'
import '@piconetworks/select-plan/dist/index.css'
import '@piconetworks/spacing/dist/index.css'
import '@piconetworks/text/dist/index.css'
import '@piconetworks/tooltip/dist/index.css'
import '@piconetworks/wizard-slider/dist/index.css'
import '@piconetworks/select-donation/dist/index.css'
import '@piconetworks/verify-email/dist/index.css'
import '@piconetworks/order-summary/dist/index.css'

import React from 'react'
import PropTypes from 'prop-types'

import {
    Router,
    Switch,
    Route,
} from 'react-router-dom'
import { connect } from 'react-redux'

import { history } from '@piconetworks/router-adapter'

import Prompt from 'apps/containers/Prompt'

import Login from 'apps/containers/Prompt/Login/Index'
import EnterEmail from 'apps/containers/Prompt/Login/EnterEmail'
import EnterPassword from 'apps/containers/Prompt/Login/EnterPassword'
import Link from 'apps/containers/Prompt/Login/Link'
import LinkConfirmation from 'apps/containers/Prompt/Login/Link/LinkConfirmation'
import Token from 'apps/containers/Prompt/Login/Token'
import Reset from 'apps/containers/Prompt/Login/Reset'

import OfferOptions from 'apps/containers/Prompt/OfferOptions'

import VerifyEmail from 'apps/containers/Prompt/VerifyEmail'

import Overlay from 'apps/containers/Prompt/Overlay'
import Checkout from 'apps/containers/Prompt/Checkout'
import CheckoutWithPlan from 'apps/containers/Prompt/CheckoutWithPlan'
import SelectPlan from 'apps/containers/Prompt/SelectPlan'

import Cards from 'apps/containers/Prompt/Cards/Index'
import AddCard from 'apps/containers/Prompt/Cards/AddCard'
import SelectCard from 'apps/containers/Prompt/Cards/SelectCard'

import ConfirmPayment from 'apps/containers/Prompt/ConfirmPayment'
import SelectNewsletters from 'apps/containers/Prompt/SelectNewsletters'
import ThankYou from 'apps/containers/Prompt/ThankYou'

import Donate from 'apps/containers/Prompt/Donate/Index'
import SelectDonation from 'apps/containers/Prompt/Donate/SelectDonation'

import Registration from 'apps/containers/Prompt/Registration'

import Gift from 'apps/containers/Prompt/Gift/Index'
import GiftForm from 'apps/containers/Prompt/Gift/GiftForm'
import RedeemGift from 'apps/containers/Prompt/Gift/RedeemGift'
import ConvertGift from 'apps/containers/Prompt/Gift/ConvertGift'
import CheckoutWithGift from 'apps/containers/Prompt/CheckoutWithGift'

import EditPassword from 'apps/containers/Prompt/Account/EditPassword'
import FinalizePayment from 'apps/containers/Prompt/FinalizePayment'

import Markdown from 'apps/containers/Prompt/Markdown'

import Offer from 'apps/containers/Prompt/Offer'

const Routes = ({
    accessToken,
}) => (
    <Router history={history}>
        <Switch>
            <Route
                exact
                path="/"
                render={(props) => <Prompt {...props} accessToken={accessToken} />}
            />

            <Route exact path="/login" render={(props) => <Overlay {...props}><Login {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/login/enter-email" render={(props) => <Overlay {...props}><EnterEmail {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/login/enter-password" render={(props) => <Overlay {...props}><EnterPassword {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/login/link" render={(props) => <Overlay {...props}><Link {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/login/link-confirmation" render={(props) => <Overlay {...props}><LinkConfirmation {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/login/token" render={(props) => <Overlay {...props}><Token {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/login/reset" render={(props) => <Overlay {...props}><Reset {...props} accessToken={accessToken} /></Overlay>} />

            <Route path="/verify" render={(props) => <Overlay {...props}><VerifyEmail {...props} accessToken={accessToken} /></Overlay>} />

            <Route path="/registration" render={(props) => <Overlay {...props}><Registration {...props} accessToken={accessToken} /></Overlay>} />

            <Route path="/checkout-with-plan" render={(props) => <Overlay {...props}><CheckoutWithPlan {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/checkout-with-gift" render={(props) => <Overlay {...props}><CheckoutWithGift {...props} accessToken={accessToken} /></Overlay>} />

            <Route path="/checkout" render={(props) => <Overlay {...props}><Checkout {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/select-plan" render={(props) => <Overlay {...props}><SelectPlan {...props} accessToken={accessToken} /></Overlay>} />

            <Route path="/gift" render={(props) => <Overlay {...props}><Gift {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/gift-form" render={(props) => <Overlay {...props}><GiftForm {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/redeem-gift" render={(props) => <Overlay {...props}><RedeemGift {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/convert-gift" render={(props) => <Overlay {...props}><ConvertGift {...props} accessToken={accessToken} /></Overlay>} />

            <Route path="/donate" render={(props) => <Overlay {...props}><Donate {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/select-donation" render={(props) => <Overlay {...props}><SelectDonation {...props} accessToken={accessToken} /></Overlay>} />

            <Route exact path="/cards" render={(props) => <Overlay {...props}><Cards {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/cards/add" render={(props) => <Overlay {...props}><AddCard {...props} accessToken={accessToken} /></Overlay>} />
            <Route path="/cards/select" render={(props) => <Overlay {...props}><SelectCard {...props} accessToken={accessToken} /></Overlay>} />

            <Route path="/confirm-payment" render={(props) => <Overlay {...props}><ConfirmPayment {...props} accessToken={accessToken} /></Overlay>} />

            <Route path="/select-newsletters" render={(props) => <Overlay {...props}><SelectNewsletters {...props} accessToken={accessToken} /></Overlay>} />

            <Route path="/thank-you" render={(props) => <Overlay {...props}><ThankYou {...props} accessToken={accessToken} /></Overlay>} />

            <Route exact path="/account/edit-password" render={(props) => <Overlay {...props}><EditPassword {...props} accessToken={accessToken} /></Overlay>} />

            <Route path="/markdown" render={(props) => <Overlay {...props}><Markdown {...props} accessToken={accessToken} /></Overlay>} />

            <Route path="/finalize-payment" render={(props) => <Overlay {...props}><FinalizePayment {...props} accessToken={accessToken} /></Overlay>} />

            <Route path="/offer" render={(props) => <Overlay {...props}><Offer {...props} accessToken={accessToken} /></Overlay>} />

            <Route path="/offer-options" render={(props) => <Overlay {...props}><OfferOptions {...props} accessToken={accessToken} /></Overlay>} />
        </Switch>
    </Router>
)

const mapStateToProps = ({
    _network: {
        access_token: {
            default: accessToken,
        },
        refresh_token: {
            default: refreshToken,
        },
    },
    loader: {
        user: {
            token,
        } = {},
    } = {},
}) => ({
    accessToken: accessToken || token,
    refreshToken,
})

Routes.defaultProps = {
    accessToken: null,
    refreshToken: null,
}

Routes.propTypes = {
    accessToken: PropTypes.string,
    refreshToken: PropTypes.string,
}

export default hot(connect(mapStateToProps)(Routes))
